<script>
  let { currentView = 'home', noteId = '', onnavigate = () => {} } = $props();

  // Compute text-only directory path segments
  let segments = $derived.by(() => {
    const items = [
      { label: '~', view: 'home' }
    ];

    if (currentView === 'notes') {
      items.push({ label: 'notes', view: 'notes', isCurrent: true });
    } else if (currentView === 'note-detail') {
      items.push({ label: 'notes', view: 'notes' });
      const filename = noteId ? `${noteId}.md` : 'note.md';
      items.push({ label: filename, view: 'note-detail', slug: noteId, isCurrent: true });
    }

    return items;
  });
</script>

<nav class="cs-path-nav" aria-label="CS Directory Path">
  {#each segments as seg, i}
    {#if i > 0}
      <span class="sep">/</span>
    {/if}
    <button 
      class="path-link {seg.isCurrent ? 'active' : ''}" 
      onclick={() => onnavigate(seg.view, seg.slug || '')}
    >
      {seg.label}
    </button>
  {/each}
</nav>

<style>
  .cs-path-nav {
    display: inline-flex;
    align-items: baseline;
    gap: 0.3rem;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    font-size: clamp(0.85rem, 1.1vw, 0.95rem);
    color: #71717a;
    user-select: none;
    line-height: 1;
    margin: 0;
    padding: 0;
  }

  .sep {
    color: #3f3f46;
    margin: 0;
    line-height: 1;
    display: inline;
  }

  .path-link {
    background: transparent;
    border: none;
    outline: none;
    color: #71717a;
    font-family: inherit;
    font-size: inherit;
    line-height: 1;
    margin: 0 !important;
    padding: 0 !important;
    cursor: pointer;
    transition: color 0.15s ease;
    display: inline;
    vertical-align: baseline;
  }

  .path-link:hover {
    color: #ffffff;
    text-decoration: underline;
  }

  .path-link.active {
    color: #f4f4f5;
    font-weight: 600;
  }

  .path-link.active:hover {
    color: #ffffff;
    text-decoration: none;
  }
</style>
